The scheme ID of the webhook subscription's events.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
